export enum Colors {
  afterdark = '#19191B',
  darkmatter = '#07070A',
  digitalwhite = '#EBEBEB',
  metablack = '#19191b',
  laserred = '#db1a27',
  cybersilver = '#c2c3c5',
  lumenyellow = '#fff760',
  quantumblue = '#144e8f',
  atomgrey = '#788396',
  futuregreen = '#c5d4ca',
  eclipseblack = '#242528',
  radiantred = '#D53845',
  platinumgoldmetallic = '#dbcdaf',
  solarsilver = '#bdb19b',
  boldwhite = '#F5F5F5',
  infiniteblack = '#191919',
  afterdarkExterior = '#26282c',
  lightning = '#F5F5F5',
  darkmatterExterior = '#26282c',
  touch = '#F5F5F5',
  brabus = '#19191B',
  vibrantbrown = '#967468',
  infinitegray = '#ACB4BB',
  ceramiccream = '#D9D2C8',
  electricblue = '#97BBD0',
  photonorange = '#FC641F',
  touchduo = '#EBE8E8',
  meteoriteblack = '#19191B',
  lighningdash = '#F5F5F5'
}

export const ColorCodeMap: Record<string, string | undefined> = {
  '096': Colors.digitalwhite,
  '026': Colors.metablack,
  '086': Colors.lumenyellow,
  '084': Colors.atomgrey,
  '085': Colors.cybersilver,
  '030': Colors.laserred,
  '102': Colors.futuregreen,
  '087': Colors.quantumblue,
  '118': Colors.electricblue,
  '119': Colors.ceramiccream,
  '117': Colors.photonorange,
  // Interior colors
  B50: Colors.darkmatter,
  B51: Colors.touch,
  A88: Colors.boldwhite,
  B48: Colors.afterdark,
  B49: Colors.lightning,
  B52: Colors.brabus,
  B55: Colors.touchduo,
  B47: Colors.meteoriteblack,
  B49X: Colors.lighningdash,
  A38: Colors.infinitegray,
  A32: Colors.infiniteblack,
  A33: Colors.vibrantbrown,
  A34: Colors.brabus,
  D05: Colors.afterdark,
  // Roof colors
  MF01: undefined,
  MF02: Colors.eclipseblack,
  MF20: Colors.platinumgoldmetallic,
  MF18: Colors.lumenyellow,
  MF19: Colors.radiantred
};

/**
 * This function converts a color name to its corresponding hexadecimal value.
 * If the color name is undefined or not found in the ColorCodeMap, it returns a fallback color.
 *
 * @param {string|undefined} color - The color name to convert to hexadecimal.
 * @param {string} [fallback=Colors.digitalwhite] - The fallback color in hexadecimal if the color name is undefined or not found.
 * @returns {string} The hexadecimal value of the color name or the fallback color.
 */
export const getHexFromColorCode = (color: string | undefined, fallback: string = Colors.digitalwhite): string => {
  if (!color) return fallback;
  return ColorCodeMap[color] ?? fallback;
};
